module.exports = __webpack_public_path__ + "static/img/153847_3_10.5ca1dcc3.jpg";